// extracted by mini-css-extract-plugin
export default {"container":"ACEYc","dialogTitle":"X8fel","formLabel":"CF9P3","emptySelect":"TR0Kd","discountTable":"i2pX6"};